"use client";

import { useCallback, useEffect, useState } from "react";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import './MembershipLayout.css'; // Assuming you have a CSS file for additional styles

export default function MembershipLayout() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-col gap-6 md:gap-12 min-h-screen"
      style={{
        backgroundImage: `url(${images.golf_field})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <Nav />
      <div className="flex justify-center md:mx-16 mb-10 md:mb-20">
        <div className="grid custom:grid-cols-[22%,78%] custom5:grid-cols-[18%,82%]  grid-cols-1 custom5:max-w-fit h-full w-full justify-center items-start lg:gap-6 md:gap-0 screen">
          <Sidebar />
          <div className="h-full w-full custom5:min-w-[70rem] custom5:max-w-fit  ">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
